import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getListPickupLocationsApi } from "../../../api/pickupLocations";

// First, create the thunk
export const fetchPickupLocation = createAsyncThunk(
  "system/fetchPickupLocation",
  async ({ query }: any) => {
    try {
      const response = await getListPickupLocationsApi(query);
      return response.data;
    } catch (error) {
      
    }
  }
);

const initialState: any = {
  isFetching: true,
  pagination: {
    total: 0,
    per_page: 10,
    current_page: 1,
    last_page: 1,
  },
  result: [],
  total: "0"
};

export const pickupLocationSlice = createSlice({
  name: "system",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(fetchPickupLocation.pending, (state) => {
      state.isFetching = true;
    });

    builder.addCase(fetchPickupLocation.rejected, (state) => {
      state.isFetching = false;
    });

    builder.addCase(fetchPickupLocation.fulfilled, (state, action) => {
      state.isFetching = false;
      state.pagination = action.payload?.pagination;
      state.result = action.payload?.data;
      state.total = action.payload?.total;
   
    });
  },
});

export const {} = pickupLocationSlice.actions;

export default pickupLocationSlice.reducer;
